var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{attrs:{"color":"transparent"}},[_vm._v("Something has gone wrong there. Please contact support")])
}
var staticRenderFns = []

export { render, staticRenderFns }